const ItemGenerator = require('../../../game_items/ItemGenerator');
const HeavyTorsoe = require('../../../game_items/equipment/torsoe/HeavyTorsoe');
const HeavyBoots = require('../../../game_items/equipment/boots/HeavyBoots');
const Hammer = require('../../../game_items/equipment/weapon/Hammer');
const Shield = require('../../../game_items/equipment/off_hand/Shield');
const getMobEquipmenAssignmentFromBags = require('../mobs/getMobEquipmenAssignmentFromBags');

const Dwarf = (level, summoner) => {
  const handle = 'dwarf';
  const types = ['dwarf', 'humanoid', 'summoned', 'tanky'];
  const bags = [
    {
      items: [
        ItemGenerator.getRandomItem(HeavyTorsoe, level / 10, level / 5),
        ItemGenerator.getRandomItem(HeavyBoots, level / 10, level / 5),
        ItemGenerator.getRandomItem(Hammer, level / 10, level / 5),
        ItemGenerator.getRandomItem(Shield, level / 10, level / 5),
      ].map((item) => ({ value: item })),
    },
  ];
  const ai_priorities = ['dps_close', 'tank', 'interference', 'support', 'dps_ranged'];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'dwarf_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          layers_of_protection: {
            handle: 'layers_of_protection',
            level: bound_level * 2,
            passive: true,
          },
          slam: { handle: 'slam', level: bound_level * 2 },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => {
      const { base, fromUpgrades, fromEquipment, fromConditions } = summoner.attributes;
      const summoner_learning =
        base.learning + fromUpgrades.learning + fromEquipment.learning + fromConditions.learning;
      return {
        learning: Math.round(2 + bound_level * 0.5 + summoner_learning * 0.1 + Math.random() * 4),
        perception: Math.round(2 + bound_level * 1.0 + summoner_learning * 0.2 + Math.random() * 4),
        mana: Math.round(2 + bound_level * 0.5 + summoner_learning * 0.1 + Math.random() * 4),
        toughness: Math.round(6 + bound_level * 2.5 + summoner_learning * 0.5 + Math.random() * 4),
        strength: Math.round(5 + bound_level * 2.0 + summoner_learning * 0.4 + Math.random() * 4),
        willpower: Math.round(3 + bound_level * 1.0 + summoner_learning * 0.2 + Math.random() * 4),
        dexterity: Math.round(2 + bound_level * 1.5 + summoner_learning * 0.3 + Math.random() * 4),
      };
    }).bind(null, level),
    getDefaultAIConfig: () => ai_priorities,
    getStarterEquipment: () => {},
    bags,
    build: {
      ai: {
        priorities: ai_priorities,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities: [{ value: 'move' }, { value: 'melee_attack' }, { value: 'slam' }],
      handle,
      level,
      team: summoner.team,
      types,
      unit: true,
    },
  };
};
module.exports = Dwarf;
